<div class="flex w-full profile--user-row">
  <app-user-common-info
    [user]="sessionService.profile()!"
    [registeredDate]="sessionService.stats().registered"
    [showLogout]="true"
    (logoutFn)="sessionService.logout()"
  ></app-user-common-info>
  <app-user-level-bar [user]="sessionService.profile()!"></app-user-level-bar>
</div>
<div class="divider horizontal w-full"></div>
<!-- <div class="profile--stats">
  @for (stat of stats(); track stat.label) {
  <app-card [color]="stat.color" [coloredValue]="!!stat.coloredValue">
    <svg-icon
      card-icon
      class="s-20 flex items-center justify-center"
      [src]="stat.icon"
    ></svg-icon>
    <span card-value [countUp]="stat.value" [options]="countUpOptions"></span>
    <span card-label>{{ stat.label }}</span>
  </app-card>
  }
</div> -->
<!-- <div class="divider horizontal w-full"></div> -->
<app-user-trade-url />
<div class="divider horizontal w-full"></div>
<div class="profile--common w-full h-full">
  <app-join-discord-widget></app-join-discord-widget>
  <app-card
    [color]="sessionService.stats().profile_privacy === 0 ? 'green' : 'red'"
    layout="status-card"
  >
    <p card-value>Profile Visibility</p>
    <div card-label>
      <div class="my-profile-badge--subtitle">
        Status:
        <span
          class="highlight"
          [class.red]="sessionService.stats().profile_privacy === 1"
          [class.green]="sessionService.stats().profile_privacy === 0"
        >
          @if (sessionService.stats().profile_privacy === 0) { Visible } @else {
          Hidden }
        </span>
      </div>
    </div>
    <div card-button>
      <button
        class="button button--style-yellow h-34 rounded-4 padding-x-12"
        (click)="toggleProfilePrivacy()"
      >
        @if (sessionService.stats().profile_privacy === 0) { Hide Stats } @else
        { Show Stats }
      </button>
    </div>
  </app-card>
</div>
